import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Icon from '../components/Icon';
import { FieldLabel, FieldInput } from '../components/FormField';
import { trackTrackerLookup } from '../lib/analytics';

const TrackApplication = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    passportNumber: '',
    fileNumber: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const passportNumber = formData.passportNumber.trim();
    const fileNumber = formData.fileNumber.trim();

    trackTrackerLookup();
    navigate(
      `/tracker/status?passport=${encodeURIComponent(passportNumber)}&file=${encodeURIComponent(fileNumber)}`
    );
  };

  return (
    <div className="min-h-screen" style={{ background: 'var(--zg-bg)' }}>
      <div className="px-6" style={{ padding: '96px 24px 0', background: 'var(--zg-surface)' }}>
        <div className="mx-auto max-w-7xl">
          <Link to="/" className="inline-flex items-center gap-2 no-underline" style={{ color: 'var(--zg-muted)' }}>
            <Icon name="arrowLeft" size={16} />
            <span>Back to Home</span>
          </Link>
        </div>
      </div>

      <section className="px-6" style={{ padding: '32px 24px 64px', background: 'var(--zg-surface)' }}>
        <div className="mx-auto max-w-3xl">
          <span className="inline-block text-white text-xs rounded-full px-4 py-1.5 mb-6" style={{ background: '#2d2a24' }}>
            Application Tracking
          </span>
          <h1 className="font-bold mb-6 leading-tight" style={{ fontSize: 60, color: 'var(--zg-ink)' }}>
            Track Your Application
          </h1>
          <p className="text-xl leading-relaxed" style={{ color: 'var(--zg-muted)' }}>
            Enter your passport number and file number below to check the latest status of your application.
          </p>
        </div>
      </section>

      <section className="px-6" style={{ padding: '80px 24px' }}>
        <div className="mx-auto max-w-xl">
          <div
            className="rounded-[24px] border px-[34px] py-10"
            style={{ borderColor: 'var(--zg-border)', background: 'var(--zg-card)', boxShadow: '0 20px 50px rgba(45,42,36,.07)' }}
          >
            <form onSubmit={handleSubmit} className="flex flex-col gap-6">
              <div>
                <FieldLabel htmlFor="passportNumber">Enter Your Passport Number *</FieldLabel>
                <FieldInput
                  id="passportNumber"
                  name="passportNumber"
                  value={formData.passportNumber}
                  onChange={handleChange}
                  required
                />
              </div>

              <div>
                <FieldLabel htmlFor="fileNumber">Enter Your File Number *</FieldLabel>
                <FieldInput id="fileNumber" name="fileNumber" value={formData.fileNumber} onChange={handleChange} required />
              </div>

              <button
                type="submit"
                className="flex items-center justify-center gap-2 h-14 rounded-full text-base font-medium text-white transition-all"
                style={{ background: '#2d2a24' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.background = '#3a362e';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.background = '#2d2a24';
                }}
              >
                <Icon name="search" size={18} color="#fff" />
                <span>Track It</span>
              </button>
            </form>
          </div>

          <div className="mt-12 text-center">
            <p className="flex items-center justify-center gap-2" style={{ color: 'var(--zg-muted)' }}>
              <Icon name="shield" size={16} />
              Your details are used only to look up your application status.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TrackApplication;
